<template>
  <div class="customPage">
    <h2 class="customPageTitle">패널티 정하기</h2>
    <v-container class="customPageContent text-center">
      <p 
        v-if="member"
        class="customPageSubtitle"
      >
        <span style="font-size: 18px;">
          <b style="color: #ffb5cc">{{ member.challenger }}</b>님과
        </span>
        <br>
        챌린지 실패에 대한 패널티를 정해주세요.
      </p>
      <v-form>
        <v-text-field 
          v-model="penalty"
          maxlength="150" 
          label="패널티"
          prepend-icon="mdi-alpha-p-circle-outline"
        ></v-text-field>
        <v-btn 
          class="customButton" 
          @click="setPenalty"
        >저장</v-btn>
      </v-form>
    </v-container>
    <span 
      v-if="alert"
      class="alert"
    >
      <v-icon class="alertIcon">mdi-alert</v-icon>
      {{ alertMessage }}
    </span>
  </div>
</template>
<script>
export default {
  name: "Penalty",
  data() {
    return {
      penalty: undefined,
      member: undefined,
      alert: false,
      alertMessage: undefined,
    };
  },
  computed: {
    challengeId() {
      return this.$store.getters.challengeId;
    },
  },
  methods: {
    getMember() {
      this.$axios
        .get("/challenges/" + this.challengeId + "/members")
        .then((response) => {
          this.member = response.data;
        });
    },
    setPenalty() {
      if(!this.penalty){
        this.alert = true;
        this.alertMessage = '패널티를 입력해주세요.';
        return false;
      }
      this.$axios
        .post("/challenges/" + this.challengeId + "/penalty", {
          penalty: this.penalty,
        })
        .then((response) => {
          this.$router.push("/");
        });
    },
  },
  mounted() {
    this.getMember();
  },
};
</script>